import { render, staticRenderFns } from "./VantShareSelectPop.vue?vue&type=template&id=5935ac03&"
import script from "./VantShareSelectPop.vue?vue&type=script&lang=js&"
export * from "./VantShareSelectPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports